<div *ngIf="loader" class="progress-bar">
  <div class="progress" [style]="'width: ' + loader.value + '%;'"></div>
</div>
